import { useMemo } from 'react';
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';
import { getUrl } from 'utils';
import {
  LocalizationLinkedList,
  PreviewApp,
  ExcludeSettingsForm,
  Loader,
  ErrorComponent,
} from 'components';
import { publisherLocalizationPages } from 'constants';
import { routes } from 'config';
import { manageAppsAPI } from 'services/manageApps.service';
import * as S from './LocalExcludeSettingsPage.styled';
import { isAdvertiserRole } from 'store/selectors';

// const publishers = [
//   {
//     pb_number: 194699,
//     pb_name: '\thardcoded data',
//   },
//   {
//     pb_number: 194700,
//     pb_name: '\thardcoded data2',
//   },
//   {
//     pb_number: 194701,
//     pb_name: '\thardcoded data3',
//   },
// ];

const LocalExcludeSettingsPage = () => {
  const { pba_id } = useParams();
  const isAdvertiser = useSelector(isAdvertiserRole);
  const pages = useMemo(() => {
    return publisherLocalizationPages
      .map((page) => {
        return { ...page, link: getUrl(routes, page.url_id, pba_id) };
      })
      .filter((pageItem) => {
        if (isAdvertiser && pageItem.display) return pageItem;
        if (!isAdvertiser) return pageItem;
      });
  }, [isAdvertiser]);

  const { data, isError, isSuccess } = manageAppsAPI.useFetchAppAdvancedDataQuery({
    pba_id,
    isAdvertiser,
  });
  const [fetchSaveOptOut, result] = manageAppsAPI.useFetchSaveOptOutMutation();

  // let newData = data ? { ...data, excluded_publishers: [...publishers] } : undefined;

  return (
    <>
      {isError && <ErrorComponent />}
      {!isSuccess && !isError && <Loader.Global delay={1} />}
      {data && (
        <S.Container>
          <h1>App Settings</h1>
          <S.Main>
            <S.Wrap>
              <S.ListPosition>
                <PreviewApp />
                <LocalizationLinkedList data={pages} show={true} />
              </S.ListPosition>
              <ExcludeSettingsForm data={data} updateAction={fetchSaveOptOut} result={result} />
            </S.Wrap>
          </S.Main>
        </S.Container>
      )}
    </>
  );
};

export default LocalExcludeSettingsPage;
